export default "__VITE_ASSET__1EWFkSNp__"